/**
 * Tai anh mau qua endpoint admin roi tra ve mot blob URL cho `<img>`.
 *
 * VI SAO KHONG DAT KEY VAO QUERY STRING:
 * `<img src>` khong gui duoc header, nen cach hien nhien la `?key=...`. Nhung middleware
 * `requestLog` cua chinh capforge ghi lai URL day du cua moi request — dat key vao query
 * la ghi thang admin key vao file log, va tu do vao moi ban backup cua log. Mot secret
 * chay qua duong nao thi phai o dung duong do.
 *
 * Vi vay: fetch bang header nhu moi loi goi API khac, roi dung `URL.createObjectURL`.
 * Doi lai phai tu thu hoi blob URL — khong thu hoi thi mot phien gan nhan vai tram anh
 * se giu lai vai tram blob trong bo nho tab cho den khi dong tab.
 */

import { useEffect, useState } from 'react';
import { getAuth } from './api';

export function useSampleImage(sampleId: number | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (sampleId === null) {
      setUrl(null);
      return;
    }

    const auth = getAuth();
    if (auth === null) {
      setUrl(null);
      return;
    }

    let revoked = false;
    let objectUrl: string | null = null;
    const controller = new AbortController();

    const headers: Record<string, string> =
      auth.mode === 'bearer'
        ? { Authorization: `Bearer ${auth.key}` }
        : { 'X-Admin-Token': auth.key };

    fetch(`/admin/samples/${sampleId}/image`, { headers, signal: controller.signal })
      .then((res) => (res.ok ? res.blob() : Promise.reject(new Error(String(res.status)))))
      .then((blob) => {
        if (revoked) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {
        // Mau chi co van ban (404 no_image) hoac file da bi don theo tran dung luong
        // (410 file_gone) deu la trang thai HOP LE, khong phai loi he thong. Man hinh
        // van hien duoc phan van ban va cac phim tat.
        if (!revoked) setUrl(null);
      });

    return () => {
      revoked = true;
      controller.abort();
      if (objectUrl !== null) URL.revokeObjectURL(objectUrl);
    };
  }, [sampleId]);

  return url;
}
